import React, { useRef, useState } from 'react'
import NoDataFound from '../../../partials/NoDataFound'
import EditExpense from '../../expenses/partials/AddOrEditExpense'
import { trans } from '../../../../_providers/Translation'
import Api from '../../../../_helpers/Api'
import { Checkbox } from '@mui/material'
import { enqueueSnackbar } from 'notistack'

function Table(props) {

    const editExpenseRef = useRef(null)
    const [toggled, setToggled] = useState({})
    const [toggledPlatform, setToggledPlatform] = useState({})

    const handleEditExpense = id => {
        editExpenseRef.current.edit(id)
    }

    const handleToggleNoPlatformMadeForCompany = (id, currentValue) => {
        setToggledPlatform(prev => ({ ...prev, [id]: !currentValue }))

        Api.post(`banktransactions/${id}/toggle-no-platform`)
            .then(() => {
                enqueueSnackbar(
                    trans('messages.changesSavedSuccessfully'),
                    {
                        variant: "success",
                    },
                )
            })
            .catch(() => {
                setToggledPlatform(prev => ({ ...prev, [id]: currentValue }))
            })
    }

    const handleToggleNotBusinessExpense = (id, currentValue) => {
        setToggled(prev => ({ ...prev, [id]: !currentValue }))

        Api.post(`banktransactions/${id}/toggle-not-business-expense`)
            .then(() => {
                enqueueSnackbar(
                    trans('messages.changesSavedSuccessfully'),
                    {
                        variant: "success",
                    },
                )
            })
            .catch(() => {
                setToggled(prev => ({ ...prev, [id]: currentValue }))
            })
    }

    return (

        props.data.length === 0
            ?
            <NoDataFound />
            :
            <>
                <EditExpense
                    ref={editExpenseRef}
                />

                <div className="table-scroller">
                    <table>
                        <thead>
                            <tr>
                                <th style={{ width: '50px' }}>ID</th>
                                <th>{trans('tables.date')}</th>
                                <th>{trans('tables.price')}</th>
                                <th>{trans('tables.orderer')}</th>
                                <th>{trans('tables.info')}</th>
                                <th>{trans('tables.file')}</th>
                                <th className="center">{trans('tables.expense')} ID</th>
                                <th>{trans('tables.creationDate')}</th>
                                <th className="center">{trans('tables.notBusinessExpense')}</th>
                                <th className="center">{trans('tables.noPlatformMadeForCompany')}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {props.data.map(t => {
                                const isNotBusinessExpense = t.id in toggled ? toggled[t.id] : Boolean(t.not_business_expense)
                                const isNoPlatform = t.id in toggledPlatform ? toggledPlatform[t.id] : Boolean(t.no_platform)
                                return (
                                    <tr key={'t-' + t.id}>
                                        <td style={{ width: '50px' }}>{t.id}</td>
                                        <td>{t.date_dmy}</td>
                                        <td>{t.expense_id ? '-' : ''}{t.amount} {t.currency && t.currency.name}</td>
                                        <td>{t.payee}</td>
                                        <td>{t.info}</td>
                                        <td>{t.file.filename}</td>
                                        <td className="center">
                                            {t.expense
                                                ?
                                                <a
                                                    // className="btn"
                                                    onClick={() => handleEditExpense(t.expense_id)}
                                                >
                                                    {t.expense_id}
                                                </a>
                                                :
                                                ''
                                            }
                                        </td>
                                        <td>
                                            {t.created_at_dmy}
                                        </td>
                                        <td className="center">
                                            <Checkbox
                                                checked={isNotBusinessExpense}
                                                onChange={() => handleToggleNotBusinessExpense(t.id, isNotBusinessExpense)}
                                            />
                                        </td>
                                        <td className="center">
                                            <Checkbox
                                                checked={isNoPlatform}
                                                onChange={() => handleToggleNoPlatformMadeForCompany(t.id, isNoPlatform)}
                                            />
                                        </td>
                                    </tr>
                                )
                            })}
                        </tbody>
                    </table>
                </div>


            </>
    )
}

export default Table